<template>
	<div>
		<filter-reports
			@generate-report="clickGenerate"
			v-if="showFilters"
			name-report="Reporte de Envíos Masivos"
			:add-user-select="false"
		/>
		<CRow class="justify-content-center" v-if="showReport">
			<CCol md="12">
				<CCard>
					<CCardHeader style="background: #97ca3d; color: #000000">
						<h4>Reporte de Envíos Masivos</h4>
					</CCardHeader>
					<CCardBody>
						<div v-if="showNotFound">
							<CRow class="content-left">
								<CCol sm="12">
									<p>
										No se econtrarón envíos para la fecha
										ingresada. Por favor intenta ingresar
										otra fecha.
									</p>
								</CCol>
							</CRow>
							<CRow class="content-center">
								<CCol sm="12">
									<b-button
										@click="generateNewReport"
										style="margin-top: 10px"
										pill
										variant="success"
									>
										Cambiar la Fecha</b-button
									>
								</CCol>
							</CRow>
						</div>
						<div v-if="showResume">
							<table-for-reports
								:fields-table="fieldsTableReport"
								:table="tableForReport"
								:total-rows="totalRows"
								@show-details="detailsForReport"
							/>
							<CRow class="content-center">
								<CCol sm="4">
									<export-excel
										:data-to-export="dataToExport"
										file-name="Envíos Masivos Realizados"
									/>
								</CCol>
								<CCol sm="4">
									<b-button
										@click="generateNewReport"
										style="margin-top: 10px"
										pill
										variant="success"
									>
										Generar Otro Reporte</b-button
									>
								</CCol>
							</CRow>
						</div>
						<div v-if="showDetails">
							<CRow>
								<CCol sm="12">
									<table-for-reports
										:fields-table="fieldsTableDetails"
										:table="tableForDetails"
										:total-rows="totalRows"
									/>
									<CRow class="content-left">
										<CCol sm="12">
											<export-excel
												:data-to-export="
													dataToExportDetails
												"
												file-name="Solicitudes de Envío Masivo"
											/>
										</CCol>
									</CRow>
									<CRow class="content-center">
										<CCol sm="12">
											<b-button
												@click="generateNewReport"
												style="margin-top: 10px"
												pill
												variant="success"
											>
												Generar Otro Reporte</b-button
											>
										</CCol>
									</CRow>
								</CCol>
							</CRow>
						</div>
					</CCardBody>
				</CCard>
			</CCol>
		</CRow>
	</div>
</template>

<script>
	import functionsReports from '../../functions/functionsForReports';
	import exportExcel from '../../components/exportExcel.vue';
	import FilterReports from '../../components/filterReports.vue';
	import tableForReports from '../../components/tableForReports';
	export default {
		name: 'MassiveRequestsSended',
		title: 'Reporte Envíos Masivos | Infoguia',
		components: {
			exportExcel,
			FilterReports,
			tableForReports,
		},
		created() {},
		data() {
			return {
				showFilters: true,
				showReport: false,
				showNotFound: false,
				showDetails: false,
				showResume: false,
				fieldsTableReport: [
					{
						key: 'categorie',
						label: 'Categoría',
					},
					{
						key: 'location',
						label: 'Localidades',
					},
					{
						key: 'sendingDate',
						label: 'Fecha de Envío',
						// thStyle: {
						//     width: '205px'
						// }
					},
					{
						key: 'requestsSent',
						label: 'Envíos Realizados',
					},
					{
						key: 'requestsVisualized',
						label: 'Visualizaciones',
					},
					{
						key: 'requestsUpdate',
						label: 'Solicitudes Recibidas',
					},
					{
						key: 'quantityProcessed',
						label: 'Procesadas',
						//tdClass: "content-right",
						thStyle: {
							width: '110px',
						},
					},
					{
						key: 'quatityRejected',
						label: 'Rechazadas',
						tdClass: 'content-right',
						thStyle: {
							width: '115px',
						},
					},
					{
						key: 'actions',
						label: 'Acciones',
						thStyle: {
							width: '100px',
						},
					},
				],
				fieldsTableDetails: [
					{
						key: 'bussinessName',
						label: 'Nombre de la Empresa',
					},
					{
						key: 'sendingDate',
						label: 'Fecha de Envío',
						//tdClass: 'content-right',
					},
					{
						key: 'status',
						label: 'Estatus',
						//tdClass: 'content-right',
					},
					{
						key: 'userName',
						label: 'Usuario',
						//tdClass: 'content-right',
					},
				],
				tableForReport: [],
				tableForDetails: [],
				dataToExport: [],
				dataToExportDetails: [],
				totalRows: 0,
				datesForDetails: null,
			};
		},
		methods: {
			clickGenerate(dataForPost) {
				this.datesForDetails = dataForPost;
				this.loadReport(dataForPost);
			},
			loadReport(dataForPost) {
				let loader = this.$loading.show();
				let quantitySent = 0;
				functionsReports
					.getReportMassiveSended(dataForPost)
					.then((response) => {
						this.totalRows = response.length;
						for (let index = 0; index < response.length; index++) {
							quantitySent = response[index].quantitySent;
							this.tableForReport[index] = {
								categorie:
									response[index].categoria.nombrecategoria,
								location: 'Nacional',
								sendingDate: response[index].sendingDate,
								requestsSent: response[index].requestsSent,
								requestsVisualized:
									response[index].requestsVisualized,
								requestsUpdate: response[index].requestsUpdate,
								quantityProcessed:
									response[index].requestsProcessed,
								quatityRejected:
									response[index].requestsRejected,
								_rowVariant: '',
								idRequests: response[index].idRequests,
							};
							this.dataToExport[index] = {
								Categoria:
									response[index].categoria.nombrecategoria,
								Localidad: 'Nacional',
								'Fecha del Envío': response[index].sendingDate,
								'Cantidad de Envíos':
									response[index].requestsSent,
								Visualizaciones:
									response[index].requestsVisualized,
								'Solicitudes Recibidas':
									response[index].requestsUpdate,
								Procesadas: response[index].requestsProcessed,
								Rechazadas: response[index].requestsRejected,
							};
							if (response[index].locationSent == 'S') {
								let statesStrin = '';
								for (
									let indexStates = 0;
									indexStates <
									response[index].estados.length;
									indexStates++
								) {
									statesStrin +=
										response[index].estados[indexStates]
											.nombreestado + ', ';
									this.tableForReport[
										index
									].location = statesStrin
										.trim()
										.slice(0, -1);
									this.dataToExport[
										index
									].Localidad = statesStrin
										.trim()
										.slice(0, -1);
								}
							} else if (response[index].locationSent == 'C') {
								let citiesString = '';
								for (
									let indexCities = 0;
									indexCities <
									response[index].ciudades.length;
									indexCities++
								) {
									citiesString +=
										response[index].ciudades[indexCities]
											.nombreciudad + ', ';
									this.tableForReport[
										index
									].location = citiesString
										.trim()
										.slice(0, -1);
									this.dataToExport[
										index
									].Localidad = citiesString
										.trim()
										.slice(0, -1);
								}
							} else if (response[index].locationSent == 'U') {
								let urbString = '';
								for (
									let indexUrb = 0;
									indexUrb <
									response[index].urbanizations.length;
									indexUrb++
								) {
									urbString +=
										response[index].urbanizations[indexUrb]
											.nameUrbanization + ', ';
									this.tableForReport[
										index
									].location = urbString.trim().slice(0, -1);
									this.dataToExport[
										index
									].Localidad = urbString.trim().slice(0, -1);
								}
							}
						}
						if (this.tableForReport.length) {
							this.showReport = true;
							this.showFilters = false;
							this.showResume = true;
						} else {
							this.showReport = true;
							this.showFilters = false;
							this.showNotFound = true;
						}
					})
					.catch((error) => {
						console.log(error);
					})
					.finally(() => {
						loader.hide();
					});
			},
			generateNewReport() {
				this.showReport = false;
				this.showFilters = true;
				this.showNotFound = false;
				this.showDetails = false;
				this.showResume = false;
				this.tableForReport = [];
				this.datesForDetails = null;
			},
			detailsForReport(dataForDetails) {
				this.loadDetails(dataForDetails.idRequests);
			},
			loadDetails(idRequests) {
				let loader = this.$loading.show();
				let datesDetail = this.datesForDetails;
				functionsReports
					.getDetailsReportMassiveSended(idRequests, datesDetail)
					.then((response) => {
						this.totalRows = response.length;
						let statusDescription = '';
						for (let tableDetails of Object.keys(response)) {
							statusDescription =
								response[tableDetails].status.description !== ''
									? ' (' +
									  response[tableDetails].status
											.description +
									  ')'
									: '';
							this.tableForDetails[tableDetails] = {
								bussinessName:
									response[tableDetails].busquedaempresa
										.nombreempresa,
								sendingDate: response[tableDetails].sendingDate,
								status:
									response[tableDetails].status.name +
									statusDescription,
								userName: response[tableDetails].user.name,
							};
							this.dataToExportDetails[tableDetails] = {
								'Nombre de la Empresa':
									response[tableDetails].busquedaempresa
										.nombreempresa,
								'Fecha del Envío':
									response[tableDetails].sendingDate,
								'Estatus de la Solicitud':
									response[tableDetails].status.name +
									statusDescription,
								'Usuario Encargado':
									response[tableDetails].user.name,
							};
						}
						this.showDetails = true;
						this.showResume = false;
					})
					.catch((error) => {
						console.log(error);
					})
					.finally(() => {
						loader.hide();
					});
			},
		},
	};
</script>
